<template>
  <div style="padding-top: 4rem; padding-bottom: 4rem">
    <p
      align="center"
      style="
        font-family: Arial, Helvetica, sans-serif;
        font-size: 2.5rem;
        font-weight: 800;
        color: #1c3e8e;
      "
    >
      Bienvenidos a Nuestro Catálogo de Productos
    </p>
    <divider-component />
    <div align="center">
      <p
        style="
          width: 50%;
          font-family: Arial, Helvetica, sans-serif;
          font-weight: 400;
        "
        align="center"
      >
        Aqui encontraras una gran variedad de productos que nosotros manejamos.
      </p>
    </div>
  </div>

  <v-container>
    <div align="center">
      <v-row>
        <v-text-field
          style="margin-right: 10px"
          color="blue"
          clearable
          label="Busca tu producto"
          variant="solo"
          prepend-inner-icon="mdi-magnify"
          v-model="Description"
        ></v-text-field>

        <v-btn
          variant="tonal"
          color="blue"
          height="55"
          @click="GetByDescription"
          >Buscar</v-btn
        >
      </v-row>
    </div>
    <v-spacer style="height: 30px"></v-spacer>
    <div class="d-flex justify-content-end">
      <div>
        <v-select
          style="height: 60px; width: 300px; margin-bottom: 50px"
          variant="solo"
          label="Busca por Categorias"
          :items="categorias"
          color="blue"
          v-model="selectedClasificacion"
        ></v-select>
      </div>
    </div>
    <v-row>
      <v-col
      cols="12"
        sm="12"
        md="6"
        lg="4"
        v-for="(item, index) in Productos"
        :key="index"
      >
        <CardProductsComponent :item="item" />
      </v-col>
    </v-row>
    <v-progress-circular
      v-if="loading"
      :size="70"
      :width="7"
      color="purple"
      :indeterminate="loading"
    ></v-progress-circular>
  </v-container>

  <div align="center" v-if="Productos.length <= 0">
    <v-card width="70%">
      <v-img :src="require('@/assets/sin-info.png')" alt="" height="150" />
      <p
        style="
          font-size: medium;
          font-family: Arial, Helvetica, sans-serif;
          font-weight: 600;
          color: blueviolet;
        "
      >
        NO SE ENCONTRO NINGUN REGISTRO :C
      </p>
    </v-card>
  </div>

  <div style="margin: 50px">
    <div v-if="selectedClasificacion != ''">
      <v-btn
        block
        color="blue"
        variant="outlined"
        @click="GetByCategory"
        style="margin: 5px"
        >Cargar más</v-btn
      >
    </div>
    <div v-if="selectedClasificacion == ''">
      <v-btn
        block
        color="blue"
        variant="outlined"
        @click="GetAllProducts"
        style="margin: 5px"
        >Cargar más</v-btn
      >
    </div>
  </div>
</template>

<script>
import CardProductsComponent from '@/components/CardProductsComponent.vue';
import ApiProductos from '@/Api/ProductosApi';
import DividerComponent from '@/components/DividerComponent.vue';
export default {
  data() {
    return {
      pageNumber: 1,
      Productos: [],
      categorias: [],
      selectedClasificacion: '',
      loading: false,
      Description: '',
    };
  },

  mounted() {
    this.GetAllProducts();
    this.GetAllCategory();
  },

  methods: {
    async GetAllProducts() {
      this.loading = true;
      await ApiProductos.getAll(this.pageNumber)
        .then((response) => {
          this.Productos = [...this.Productos, ...response.data];
          this.pageNumber++;
          this.loading = false;
        })
        .catch((error) => {
         
          this.loading = false;
        });
    },

    async GetAllCategory() {
      await ApiProductos.getAllClasificaciones()
        .then((response) => {
          this.categorias = response.data;
        })
        .catch((error) => {
         
        });
    },

    async GetByCategory() {
      this.loading = true;

      if (
        this.selectedClasificacion != '' &&
        this.selectedClasificacion != '(Ninguna)'
      ) {
        await ApiProductos.getByClasificaciones(
          this.selectedClasificacion,
          this.pageNumber
        )
          .then((response) => {
            this.Productos = [...this.Productos, ...response.data];
            this.loading = false;
            this.pageNumber++;
          })
          .catch((error) => {
         
            this.loading = false;
          });
      } else {
        this.GetAllProducts();
      }
    },
    async GetByDescription() {
      this.loading = true;
      await ApiProductos.GetByDescription(this.Description)
        .then((response) => {
          this.Productos = response.data;
          this.loading = false;
        })
        .catch((error) => {
        
          this.loading = false;
        });
    },
  },
  watch: {
    selectedClasificacion() {
      this.Productos = [];
      this.pageNumber = 1;
      this.GetByCategory();
    },
  },
  components: {
    CardProductsComponent,
    DividerComponent,
  },
};
</script>

<style></style>
